module.exports = __webpack_public_path__ + "2cb3ebf0873c0f0f6e5a7b542bc6006b.jpg";